<script lang="ts" setup>
import { useClimbingNumber } from '../composables/useClimbingNumber'

const props = withDefaults(
  defineProps<{
    value: number
    /**
     * Whether this number is still being added to. Only a service that is running has progress to show —
     * a finished one's counts are what it came to, and a run opened from the history list would otherwise
     * animate a figure that stopped moving days ago.
     */
    climbing?: boolean
  }>(),
  { climbing: false }
)

const shown = useClimbingNumber(
  () => props.value,
  () => props.climbing
)
</script>

<template>{{ shown.toLocaleString() }}</template>
